import LoginPanel from "./components/LoginPanel";
import Cookies from 'js-cookie'

import React from 'react'
import { ToastContainer } from 'react-toastify'
import { LoginContext, LoginProvider } from "./contexts/LoginContext";

import { axiosGet, axiosPost } from '../common/js/axios-utility'

import { type LoginData } from "../common/js/bfx-customer-utility";

export default function App() {
    const onLoginComplete = (data: LoginData) => {
        const params = new URLSearchParams(window.location.search);
        const sso = params.get('sso');
        const sig = params.get('sig');
        const source = params.get('source');
        if (sso && sig) {
            discourseLogin(sso, sig, data);
        }
        else if (source == 'zendesk') {
            zendeskLogin(data);
        }
        else if (source == 'bfxd') {
            const token = params.get('token');
            if (token){
                bfxdLogin(data, token);
            }
        }
        else {
            if (data.email_verified) {
                doRedirect();
            }
        }
    }

    const doRedirect = () => {
        const params = new URLSearchParams(window.location.search);
        const returnUrl = params.get('redirect_url') || Cookies.get('redirect_url') || '/account/myaccount';
        Cookies.remove('redirect_url');
        window.location.href = returnUrl;
    }

    const discourseLogin = async (sso: string, sig: string, login: LoginData) => {
        grecaptcha.ready(async function () {
            const grecapToken = await grecaptcha.execute('6LeQ58wUAAAAAOO3JdYg_gxcIMwN9GXg8cWkz1i_', { action: 'discourse_login' })
            const payload: any = {
                sso: sso,
                sig: sig,
                'g-recaptcha-response': grecapToken
            }
            const params = Object.keys(payload).map(function(k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k])
            }).join('&');
            const {data : redirectUrl} = await axiosGet(
                'https://backend.borisfx.com/discourse_loginv3?' + params, 
                { auth: { username: login.email, password: login.token } }
            )
            window.location.href = redirectUrl;
        })
    }

    const zendeskLogin = async (login: LoginData) => {
        var payload = {
            email: login.email,
            token: login.token
        }
        try{
            const {data : zdJwt} = await axiosPost('/zendesk_login', payload);
            window.location.href = 'https://borisfx.zendesk.com/access/jwt?jwt=' + zdJwt;
        }
        catch(err){
            window.location.href='/account/myaccount';
        }
    }

    const bfxdLogin = async (login: LoginData, bfxdToken: string) => {
        const payload = {
            requestToken: bfxdToken
        };
        try{
            await axiosPost('/bfxd/login/init', payload, { auth: { username: login.email, password: login.token } })
            var url = '/account/bfxd-login-complete/?token=' + payload.requestToken + '&email=' + encodeURIComponent(login.email);
            window.location.href = url;
        }
        catch(err){
            console.error(err);
        }
    }

    return (
        <div>
            <LoginProvider>
                <div className="login-page-container">
                    <div className="login-page-content box box-accent">
                        <LoginPanel onComplete={onLoginComplete} />
                    </div>
                </div>
            </LoginProvider>
            <ToastContainer />
        </div>
    )
}
